import { inject, ref } from 'vue';
const SR = function () {
  this.version = '0.5';
  this.debug = true;
  this.recognition = null; //for now (v1.5) only chrome, safari (!) and edge (but no dutch)
  this.recognitionResultCb = null;
  this.startCB = null;
  this.recognitionErrorCb = null;
  this.recognitionEndCb = null;
  this.isEnabled = false;
  this.isRecognising = ref(false); //luistert naar opname boolean is alleen maar voor  interface
  this.hasResult = false; // true als er een final resultaat is
  this.interimResult = '';
  this.confidence = 0;
  /* 
  de getUserMedia triggert de toegang tot de microfoon lijkt  deviceniveau * en de speechrecognition op appniveau?
  * als je de getusermedia weglaat op Safari dan werkt de speechrecognition niet.
  * de mac laat een microfoon zien in de bovenbalk bij getUserMedia en een microfoon in de browseradresbalk bij speechrecognition
      
  */
  this.init = async (lang) => {
    const me = this;

    const isAndroid = /Android/.test(navigator.userAgent);
    if (!isAndroid) {
      try {
        // werkt NIET via http! (developer) alleen https.
        await navigator.mediaDevices.getUserMedia({ audio: true });
      } catch (error) {
        this.isEnabled = false;
        throw error;
      }
    }

    try {
      this.recognition = window.SpeechRecognition
        ? new window.SpeechRecognition()
        : new window.webkitSpeechRecognition();

      /* events:
      audiostart  - start capture audio
      audioend - finish capture
      V end - disconnect van service -> is mogelijk wel belangrijk
      V error
      V result
      soundstart
      soundend -> system has detected sound ending

      nomatch
      V speechend
      V start -> recognition service has begun listening!

      */

      if (window.webkitSpeechGrammarList || window.SpeechGrammarList) {
        const grammar = '#JSGF V1.0;';
        const speechRecognitionList = window.webkitSpeechGrammarList
          ? new window.webkitSpeechGrammarList()
          : new window.SpeechGrammarList();
        speechRecognitionList.addFromString(grammar, 1);
        this.recognition.grammars = speechRecognitionList;
        this.log('there is a grammarlist available', speechRecognitionList);
      } else {
        this.log('no grammarlist available');
      }

      this.recognition.continuous = false;
      this.recognition.interimResults = true;
      if (lang == 'nl') {
        this.recognition.lang = 'nl-NL';
      } //else defaults to english.

      this.log('launched recognition lang:' + lang);

      this.recognition.maxAlternatives = 1; // aantal alternatieven, maar we gebruiken alleen het alternatief met het hoogste confidence
      this.setup = true;
      this.recognition.onstart = () => {
        me.hasResult = false;
        if (me.startCB) {
          me.startCB();
        }
      };

      this.recognition.onresult = (event) => {
        /*results: {
          0: {
            0: {
              confidence: 0.695017397403717,
              transcript: "look Mum I'm talking into a web page!"
            },
            isFinal:true,
            length:1
          },
          length:1
        },*/

        const last = event.results.length - 1;
        const result = event.results[last];
        const confidence = result[0].confidence;
        const transcript = result[0].transcript;
        const isFinal = result.isFinal;

        if (isFinal) {
          me.log(
            `isFinal result lang: ${this.recognition.lang}, confidence: ${confidence}, transcript: ${transcript}`,
          );
          me.hasResult = true; // we hebben een final resultaat, dus we kunnen de hasResult flag zetten.
          me.interimResult = '';
          if (me.recognitionResultCb) {
            me.recognitionResultCb(transcript, confidence);
          }
        } else {
          me.interimResult += transcript;
          me.confidence = confidence; //laatste confidence die gemeten is.
        }
      };

      this.recognition.onerror = (event) => {
        // error event network is een probleem met webkitSpeechrecognition.
        // maar kan ook bij opstarten een (eenmalig) probleem zijn.
        switch (event.error) {
          case 'network':
            if (me.setup) {
              me.errorlog(
                'Network error occurred during speech recognition setup probably Android',
              );
            } else {
              me.errorlog('Network error occurred during speech recognition.');
              me.isEnabled = false;
            }
            break;
          case 'audio-capture':
            me.errorlog(
              'Error capturing audio. Please check your microphone and permissions.',
            );
            me.isEnabled = false;
            break;
          case 'language-not-supported':
            me.errorlog('Err Language not supported');
            me.isEnabled = false;
            break;
          case 'no-speech':
            me.errorlog('Err.... No speech was detected.');
            break;
          case 'aborted':
            //gedurende setup fired deze ook, maar is niet erg.
            if (!me.setup) {
              me.errorlog(`Speech recognition was aborted. ${event.message}`);
            }
            break;
          case 'not-allowed':
            me.errorlog(
              'Speech recognition is not allowed. Please check your permissions.',
            );
            me.isEnabled = false;
            break;
          case 'service-not-allowed':
            me.errorlog('Speech recognition service is not allowed.');
            me.isEnabled = false;
            break;
          case 'bad-grammar':
            me.errorlog(
              'There is an issue with the speech recognition grammar.',
            );
            me.isEnabled = false;
            break;
          default:
            me.errorlog('An unknown error occurred:', event.error);
            me.isEnabled = false;
            break;
        }

        //error die we kunnen negeren die hoeven we niet te melden.
        if (me.isEnabled) {
          return;
        }
        if (me.recognitionErrorCb) {
          me.recognitionErrorCb(event.error);
        }
      };

      /* The speechend event of the Web Speech API is fired when speech recognized by the speech * recognition service has stopped being detected.
       * this event fired before the onend event.
       * in the talk to the flag game, onspeechend does not necessarily occur.
       * after onspeechend, onend is fired, so
       */

      /* The onend property of the SpeechRecognition interface represents an event handler that will
       * run when the speech recognition service has disconnected (when the end event fires.)
       * The end event of the Web Speech API SpeechRecognition object is fired when the speech recognition service has disconnected.
       * edge case: when for example  langauge is missing, the onend-event will also fire so we check if we are enabled
       */

      /* volgorde op android : 
       started
       speechend
       onnomatch
       onend

       raar: startRecognition vuurt nu. recognising is true
    */

      this.recognition.onnomatch = () => {
        me.log('No speech recognized - nomatch event');
      };

      this.recognition.onend = () => {
        me.isRecognising.value = false;
        if (!me.hasResult) {
          /* als er geen final resultaat is, dan heeft de spreker:
           * a) mogelijk niets gezegd
           * b) er is onherkenbaar gesproken
           * c) er is door de timer heen gepraat, dwz speechrecogntion.stopRecognition() is aangeroepen, en dan kan er NOOIT een final resultaat zijn.
           * we sturen in al deze gevallen het de interimResult, wat dus ook leeg kan zijn.
           */
          if (me.interimResult == '') {
            me.confidence = 100;
          }
          if (me.recognitionResultCb) {
            me.recognitionResultCb(me.interimResult, me.confidence);
          }
        }
        if (me.recognitionEndCb) {
          me.recognitionEndCb();
        }
      };

      /*The onnomatch property of the SpeechRecognition interface represents an event handler that will run when the speech recognition service returns a final result with no significant recognition (when the nomatch event fires.)
    ik gebruik deze niet want onresult wordt ook getriggerd bij geen match.
    je zou onnomatch wel kunnen gebruiken als je sneller resultaat wilt.
    */

      //dit throws een error op bijv mobile android, waar webkitSpeechrecognition wel gemaakt kan worden maar er een error:"network" terugkomt bij setup
      //probleem geeft dit.this.recognition.start()
      //this.recognition.stop()

      if (isAndroid) {
        await new Promise(async (resolve, reject) => {
          //set enabled is true to run the android test properly.
          me.isEnabled = true;
          // For Android, start recognition briefly to initialize microphone permissions
          await me.startRecognition(
            (errorString) => {
              me.log('error android recognition error.');
              me.isEnabled = false;
              reject(
                new Error(
                  `Android speech recognition setup failed: ${errorString}`,
                ),
              );
            },
            () => {
              me.log('start android test');
            },
            () => {
              me.log('result on android');
            },
            () => {
              me.log('end android test.');
              me.isEnabled = true;
              resolve();
            },
          );
          // de timeout calls het einde van de android test en bij success wordt die geresolved.
          setTimeout(() => {
            me.log('stopping test Android recognition.');
            me.stopRecognition();
          }, 1500);
        });
      } else {
        this.isEnabled = true;
      }
    } catch (error) {
      me.errorlog('Error setting up speech recognition:', error);
      this.isEnabled = false;
      throw error;
    }
  };

  // api calls:
  this.stopRecognition = () => {
    if (!this.recognition) {
      return;
    }
    this.log('stopping recognition');
    //this.recognition.abort();// drops complete recognition..... we don't want this.
    this.isRecognising.value = false;
    this.recognition.stop();
  };

  /* starts recognition, returns success if started correctly */

  this.startRecognition = async (errorCB, startCB, resultCB, endCB) => {
    /* ff checken hier op de permissions. Er moet iets slimmers zijn om dit te gebruikenals eerste test.
     */
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'microphone' }).then((result) => {
        if (result.state === 'granted') {
          console.log('Microphone permission granted');
        } else if (result.state === 'denied') {
          console.log('Microphone permission denied');
        } else if (result.state === 'prompt') {
          console.log('Microphone permission prompt (not yet decided)');
        }
      });
    }

    if (!this.isEnabled) {
      this.errorlog('cant start, speech recognition is not enabled');
      return;
    }
    if (!errorCB || !resultCB) {
      this.errorlog('errorCB and resultCB Callbacks are required');
      return;
    }
    if (document.visibilityState === 'hidden') {
      this.errorlog('cant start, document is hidden');
      return;
    }

    this.recognitionResultCb = resultCB;
    this.startCB = startCB;
    this.recognitionErrorCb = errorCB;
    this.recognitionEndCb = endCB;
    this.interimResult = '';
    this.confidence = 0;
    if (this.isRecognising.value === true) {
      this.log('startRecognition recognising is already true!');
      return;
    }

    this.log('startRecognition recognising set to true!');
    this.isRecognising.value = true;
    try {
      this.hasResult = false; // reset hasResult flag
      this.recognition.start();
    } catch (e) {
      this.errorlog("can't start recognition?", e);
      this.isRecognising.value = false;
      return;
    }
  };

  this.log = (msg) => {
    if (this.debug) {
      console.log(msg);
    }
  };

  this.errorlog = (msg, obj) => {
    if (this.debug) {
      console.error(msg, obj);
    }
  };
};

const srSymbol = Symbol();
const speechrecognition = new SR({});

const useSpeechRecognition = () => {
  const speechrecognition = inject(srSymbol);
  if (!speechrecognition) throw new Error('No speechrecognition provided!');

  return speechrecognition;
};

export { speechrecognition, useSpeechRecognition, srSymbol };
